import React, { useState } from "react";
import styles from "./style.module.scss";
import { Link } from "gatsby";
import logo from "../../../static/logo.png";

export const NAVIGATION_ITEMS = [
  { text: "製造過程", href: "/#process" },
  { text: "事業について", href: "/#work" },
  { text: "会社概要", href: "/#about" },
  { text: "お問い合わせ", href: "/#contact" },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className={styles.header} data-open={isOpen}>
      <Link to="/">
        <img src={logo} alt="Miyazawa logo" className={styles.logo} />
      </Link>
      <div className={styles.menu} onClick={toggle}>
        <span data-open={isOpen} className={styles.topBorder}></span>
        <span data-open={isOpen} className={styles.centerBorder}></span>
        <span data-open={isOpen} className={styles.bottomBorder}></span>
      </div>
      <ul className={styles.links} data-open={isOpen}>
        {NAVIGATION_ITEMS.map((headerItem, index) => (
          <li key={index}>
            <a className={styles.link} href={headerItem.href}>
              <button onClick={toggle}>{headerItem.text}</button>
            </a>
          </li>
        ))}
      </ul>
    </header>
  );
};

export default Header;
